import { StyleSheet } from 'react-native'

const useStyles = (theme, isTablet) => StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: isTablet ? 40 : 20
  },
  rateContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 15
  },
  rateBadge: {
    marginLeft: 10,
    paddingHorizontal: 15,
    paddingVertical: 5,
    borderRadius: 14,
    backgroundColor: theme.CATSKILL_WHITE
  },
  buttonContainer: {
    alignItems: isTablet ? 'center' : 'stretch'
  }
})

export default useStyles
